import React from "react";
import SelectableCard from './SelectableCard'
export default class SelectableTitleCard extends React.Component {
  render() {
    var { title, description, selected } = this.props;
    return (
      <SelectableCard onClick={this.props.onClick} selected={selected}>
        <div className="rrcontent">
          <h1 className="title">{title}</h1>
          <p className="description">{description}</p>
        </div>
      </SelectableCard>
    );
  }
}
